import { RouteRecordRaw } from 'vue-router';

import {
  useEditCompanyStore,
  useRootStore,
} from '@/store';

// 企業関連
export const companyRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Company',
    component: () => import('@/components/pages/company/index.vue'),
    path: '/company',
    meta: {
      title: '企業',
      requiredAuthority: 'COMPANIES',
    },
  },
  {
    name: 'CompanyId',
    component: () => import('@/components/pages/company/detail/index.vue'),
    path: '/company/:id',
    meta: {
      title: '企業詳細',
      requiredAuthority: 'COMPANIES',
    },
  },
  {
    name: 'CompanyEdit',
    component: () => import('@/components/pages/company/detail/edit/index.vue'),
    path: '/company/:id/edit',
    meta: {
      title: '企業編集',
      requiredAuthority: 'EDIT_COMPANIES',
    },
    beforeEnter: async (to, from, next) => {
      const id = to.params.id.toString();

      const editCompanyStore = useEditCompanyStore();

      // 確認画面以外から遷移した場合はstoreに詳細APIを叩いた結果をセットし、formをリセットする
      if (from.name !== 'CompanyDetailEditConfirm') {
        await editCompanyStore.setInitData(id);
        editCompanyStore.$resetForm();
        useRootStore().$reset();
      }
      next();
    },
  },
  {
    name: 'CompanyDetailEditConfirm',
    component: () => import('@/components/pages/company/detail/edit/confirm/index.vue'),
    path: '/company/:id/edit/confirm',
    meta: {
      title: '企業編集確認',
      requiredAuthority: 'EDIT_COMPANIES',
    },
    beforeEnter: async (to, from, next) => {
      const id = to.params.id.toString();
      const store = useEditCompanyStore();
      const {
        form,
        initData,
      } = store;

      if (from.path === `/company/${id}/edit` && !(form == null || initData == null)) {
        next();
      } else {
        next({ path: `/company/${id}`, replace: true });
      }
    },
  },
];
